<svelte:options tag={null} />

<script lang="ts">
  export let id: string;
  export let label: string;
  export let requirementtext: string;
  export let helpid: string;
  export let helptext: string;
  export let errorid: string;
  export let errormessage: string;
  export let isinvalid = false;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
</script>

<div class="mc-field" {...attributes}>
  <label for={id} class="mc-field__label">
    {label}
    {#if requirementtext}
      <span class="mc-field__requirement" aria-hidden="true">
        {requirementtext}
      </span>
    {/if}
  </label>
  {#if helpid && helptext}
    <span id={helpid} class="mc-field__help">
      {helptext}
    </span>
  {/if}
  <slot />
  {#if isinvalid}
    <span id={errorid} class="mc-field__error-message">
      {errormessage}
    </span>
  {/if}
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';
  @import '@mozaic-ds/styles/components/c.fields';
</style>
